window.addEventListener("load", function () {
  try {
    const MAX_VERDN_REBUY_LISTENS = 100;
    const WAIT_TIME_MS_BETWEEN_VERDN_REBUY_LISTENS = 250;
    const REBUY_SMART_CART_INJECTION_POINT_SELECTOR =
      "#rebuy-cart .rebuy-cart__flyout-recommendations";

    const VERDN_MODAL_HEADING_OVERRIDE = '1 Bestellung = 1 Baum gepflanzt';
    const VERDN_MODAL_PARAGRAPH_OVERRIDES = [
      "Wenn du bei SillySanta einkaufst, werden dank dir Mangrovenbäume in Madagaskar, Mosambik oder Kenia gepflanzt.",
      "Mangrovenwälder spielen in Küstenökosystemen eine wichtige Rolle. Sie speichern viermal so viel Kohlenstoff wie tropische Regenwälder, was sie zu einem wichtigen Instrument im Kampf gegen den Klimawandel macht.",
      "Die Bäume werden von Eden Reforestation Projects gepflanzt. Das Pflanzen von Bäumen verschafft den Dorfbewohnern ein bedeutendes Einkommen, das ihnen ermöglicht, ihre Familien zu unterstützen.",
      "Wenn du deine Bestellung bei uns abgeschlossen hast, kannst du deinen Baum in einem von Verdn bereitgestellten Dashboard weiterverfolgen. Wie cool ist das denn? 🌳"
    ];

    let verdn_rebuy_listens = 0;
    const rebuyCheckInterval = setInterval(function () {
      if (verdn_rebuy_listens > MAX_VERDN_REBUY_LISTENS) {
        clearInterval(rebuyCheckInterval);
      } else {
        verdn_rebuy_listens += 1;
      }

      if (window.Rebuy && window.Rebuy.SmartCart.status === "ready") {
        try {
          injectVerdnCartBadgeIntoRebuy();
          startListeningForVerdnModal();
        } catch (err) {
          console.error(
            "[Verdn Cart Element Injector] Rebuy injection failed with error:",
            err
          );
        }
        clearInterval(rebuyCheckInterval);
      }
    }, WAIT_TIME_MS_BETWEEN_VERDN_REBUY_LISTENS);

    function startListeningForVerdnModal() {
      let verdn_modal_listens = 0;
      const verdnModalCheckInterval = setInterval(function () {
        if (verdn_modal_listens > MAX_VERDN_REBUY_LISTENS) {
          clearInterval(verdnModalCheckInterval);
        } else {
          verdn_rebuy_listens += 1;
        }

        if (document.querySelector(".verdnModalWindow")) {
          try {
            overrideVerdnModal();
          } catch (err) {
            console.error(
              "[Verdn Cart Element Injector] Modal injection failed with error:",
              err
            );
          }
          clearInterval(verdnModalCheckInterval);
        }
      }, WAIT_TIME_MS_BETWEEN_VERDN_REBUY_LISTENS);
    }

    function injectVerdnCartBadgeIntoRebuy() {
      const cartBadgeElement = document.querySelector("#x-verdn-cause-badge-x");
      const smartCartInjectionPointElement = document.querySelector(
        REBUY_SMART_CART_INJECTION_POINT_SELECTOR
      );

      smartCartInjectionPointElement.prepend(cartBadgeElement);
    }

    function overrideVerdnModal() {
      const verdnModalHeadingContainerElement = document.querySelector(
        ".verdnModalWindow > div"
      );
      const verdnModalHeadingElement = document.querySelector(
        ".verdnModalWindow h2"
      );
      const verdnParagraphTextContainerElement = document.querySelector(
        ".verdnModalWindow > div:nth-child(2)"
      );
      const verdnParagraphElementToClone = document.querySelector(
        ".verdnModalWindow > div:nth-child(2) > p"
      );
      const poweredByVerdnModalLineElement = document.querySelector(
        ".verdnModalWindow > p"
      );

      // Remove header background image
      verdnModalHeadingContainerElement.style.backgroundImage =
        "url('https://assets.verdn.com/impact-section/uploads/fcee34bc-0897-4807-8af3-0bdd5431fe52.jpg?w=1200')";

      // Replace and resize header text
      verdnModalHeadingElement.innerText = VERDN_MODAL_HEADING_OVERRIDE;

      // Replace body text elements
      const newParagraphElements = VERDN_MODAL_PARAGRAPH_OVERRIDES.map(
        function (pText) {
          const newParagraphElement = verdnParagraphElementToClone.cloneNode();
          newParagraphElement.innerText = pText;
          return newParagraphElement;
        }
      );

      verdnParagraphTextContainerElement.replaceChildren();

      newParagraphElements.forEach(function (pEl) {
        verdnParagraphTextContainerElement.appendChild(pEl);
      });

      poweredByVerdnModalLineElement.remove();

      // Add click event listener to toggleModal
      document
        .querySelector("#x-verdn-cause-badge-x")
        .removeEventListener("click", window.verdn_toggleModal);
      document
        .querySelector("#x-verdn-cause-badge-x")
        .addEventListener("click", window.verdn_toggleModal);

      // Place Verdn modal above rebuy cart
      verdn_modalBase.style.zIndex = 2147483639;
    }
  } catch (err) {
    console.error(
      "[Verdn Cart Element Injector] Injection failed with error:",
      err
    );
  }
});
